module.exports = __webpack_public_path__ + "img/banner01-desktop.932fb16f.webp";